import { Directive, Input } from '@angular/core';

/**
 * Directive to mark the DOM element as exportable
 */
@Directive({
  selector: '[appExportable]',
  standalone: false
})
export class ExportableDirective {
  /*
   * Adds a page break after the current table
   */
  @Input() pageBreak?: boolean;
}
